// extracted by mini-css-extract-plugin
export default {"partnerWapper":"OurPartner_partnerWapper__c+PMk","sectionHeading":"OurPartner_sectionHeading__Y9-Ji","partnerImage":"OurPartner_partnerImage__+7Nn0"};